import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loaded: false,
      mid: '',
      encrypted_zid: '',
      policyVersion: '',
      showError: false
    };
  },
  head() {
    return {
      title: 'EXTRA - Thanks!'
    };
  },
  computed: {},
  async mounted() {
    if (!this.$route.query.mid || !this.$route.query.encrypted_zid) {
      this.showError = true;
      console.error('[PolicyAgreement] ID not provided for user responding to policy email');
    }
    this.mid = this.$route.query.mid;
    this.encrypted_zid = this.$route.query.encrypted_zid;
    if (!this.$route.query.policyKey) {
      this.showError = true;
      console.error('[PolicyAgreement] policy not provided for user responding to policy email');
    }
    this.policyVersion = this.$route.query.policyKey;
    const payload = {
      mid: this.mid,
      encrypted_zid: this.encrypted_zid,
      policy_version: this.policyVersion
    };
    const typeformEnabled = this.$growthbook.isFeatureOn('cs5_typeform_sld_handling');
    if (!this.showError) {
      await this.$axios.$post('/api/members/agreement-email', payload).then(({
        user_id_decrypted,
        email
      }) => {
        console.log('[PolicyAgreementEmail] redirecting for zid', user_id_decrypted, typeformEnabled);
        if (typeformEnabled) {
          window.location.href = `https://getextra.typeform.com/to/qlIVqSfd#user_id=${user_id_decrypted}&email=${email}`;
        }
      }).catch(error => {
        this.showError = true;
        console.error(error);
      });
    }
  }
};